<!-- Export coverage report modal -->
<app-modal [modalId]="'coverageReport'" [showCloseAlert]="false" [showDoneBtn]="false" [modalSize]="'big'"
  (closeEvent)="onCancelClick()">
  <modal-div class="title-text">
    Coverage Report
  </modal-div>

  <modal-div class="body-content">
    <section class="row justify-content-center pt-4" id="pgModalContent">
      <div class="col-md-11 col-lg-10 col-xl-8">
        <!-- Step 1 start -->
        <ng-container *ngIf="currentStep===1">
          <div class="modal-subheading mb-3">
            <div class="row align-items-center" id="createNewPacingGuideContent">
              <div class="col-10">
                <p class="mb-0">Select the Source information for which you want to generate the report</p>
              </div>
              <div class="col-2 font-bold text-right modal-steps">
                <p class="mb-0 text-uppercase">Step 1 of 2</p>
              </div>
            </div>
          </div>
          <p class="mt-2">Fields marked with an asterisk (<span class="mandatory">*</span>) are
            required.</p>

          <div class="form-group">
            <p class="font-bold mb-0">Source Name</p>
            <p class="mb-0">{{sourceTaxonomytitle}}</p>
          </div>

          <div class="dropdown form-group">
            <app-auto-complete [listingObj]="nodetypeList"
              (selectedObject)="selectFromAutocomplete($event, 'nodetype', 'source')" [selectType]="'multi'"
              [uniqueId]="'node_type_id'" [propName]="'display_name'" [autoCompleteTitle]="'Node Type'"
              [clearArray]="true" [disableOption]="true" [viewLocation]="'covreport'" #autoCompleteNodetype>
            </app-auto-complete>
          </div>

          <div class="col-11 pl-0 pr-1" *ngIf="sourceNodeTypes.length > 0">
            <ul class="list-unstyled overide p-0">
              <li class="form-row" *ngFor="let data of sourceNodeTypes;let index=index">
                <ul class="list-unstyled d-flex w-100">
                  <li class="col-11 pl-0 font-bold"> {{data.display_name}} </li>
                  <li class="col-1 text-right">
                    <button class="btn btn-clear tooltip top lg position-relative" data-tooltip="Delete node type"
                      (click)="deleteValueFromAutoComplete(data, 'source')" [attr.aria-label]="'Delete node type'"><em
                        class="material-icons-outlined font-4x" aria-hidden="true">delete</em></button>
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <div class="col-12 text-center">
            <p class="font-bold">OR</p>
          </div>

          <div class="form-group" *ngIf="sourceTaxonomyData && !taxonomyLoading">
            <div class="form-label font-bold" id="projectTaxonomyLabel">Select the Node(s) <span class="mandatory"
                >*</span></div>
            <div class="col-12 project-section pt-3" aria-required="true"
              aria-labelledby="projectTaxonomyLabel projectSectionHelp">
              <app-tree-view [treedata]='sourceTaxonomyData'
                (selectedNodesDetail)="onTreeNodeSelectedEvent($event, 'source')"></app-tree-view>
            </div>
          </div>
        </ng-container>
        <!-- Step 1 end -->

        <!-- Step 2 start -->
        <ng-container *ngIf="currentStep===2">
          <div class="modal-subheading">
            <div class="row align-items-center mb-4" id="createNewPacingGuideContent">
              <div class="col-10">
                <p class="mb-0">Select the Target information for which you want to generate the report</p>
              </div>
              <div class="col-2 font-bold text-right modal-steps">
                <p class="mb-0 text-uppercase">Step 2 of 2</p>
              </div>
            </div>
          </div>
          <div class="row h-100">
            <div class="col-8">
              <div class="dropdown form-group">
                <p class="font-bold mb-2">
                  Target <span class="mandatory">*</span>
                </p>
                <app-tab [viewLocation]="'coverage-report'" [tabItems]='tabItems' [currentTab]="currentTab"
                  (tabSelectedEvent)="onTabSelected($event)">
                </app-tab>
                <app-auto-complete [listingObj]="dropdownList"
                  (selectedObject)="selectFromAutocomplete($event, 'taxonomy', 'target')" [selectType]="'single'"
                  [uniqueId]="'document_id'" [propName]="'title'" [autoCompleteTitle]="'Target'" [clearArray]="false"
                  [disableOption]="true" [isLableShow]="false" #autoCompleteTaxonomy>
                </app-auto-complete>
                <p id="pacingGuideTaxonomyHelp" class="form-text text-muted text-right">Select
                  the Target that you'd use for building report.
                </p>
              </div>

              <div class="dropdown form-group">
                <app-auto-complete [listingObj]="selectedTargetTaxonomyNodetypeList"
                  (selectedObject)="selectFromAutocomplete($event, 'nodetype', 'target')" [selectType]="'multi'"
                  [uniqueId]="'node_type_id'" [propName]="'display_name'" [autoCompleteTitle]="'Node Type'"
                  [clearArray]="true" [disabled]="selectedTargetTaxonomy ? false : true" [disableOption]="true"
                  [viewLocation]="'covreport'" #autoCompleteNodetype>
                </app-auto-complete>
              </div>

              <div class="col-11 pl-0 pr-1" *ngIf="targetNodeTypes.length > 0">
                <ul class="list-unstyled overide p-0">
                  <li class="form-row" *ngFor="let data of targetNodeTypes;let index=index">
                    <ul class="list-unstyled d-flex w-100">
                      <li class="col-11 pl-0 font-bold"> {{data.display_name}} </li>
                      <li class="col-1 text-right">
                        <button class="btn btn-clear tooltip top lg position-relative" data-tooltip="Delete node type"
                          (click)="deleteValueFromAutoComplete(data, 'target')"
                          [attr.aria-label]="'Delete nodetype'"><em class="material-icons-outlined font-4x" aria-hidden="true">delete</em></button>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>

              <div class="col-12 text-center">
                <p>OR</p>
              </div>
              <div class="col-12">
                <p>Fields marked with an asterisk (<span class="mandatory">*</span>) are required.
                </p>
              </div>
              <div class="form-group">
                <label class="font-bold" for="associatedTaxonomy" id="associatedTaxonomyLabel">Select
                  the Node(s)
                  <span class="mandatory">*</span>
                </label>
                <div class="taxonomy-container blank" id="associatedTaxonomy" aria-labelledby="associatedTaxonomyLabel"
                  aria-required="true">
                  <ng-container *ngIf="!taxonomyLoading">
                    <ng-container *ngIf="targetTaxonomyData">
                      <app-tree-view [treedata]='targetTaxonomyData'
                        (selectedNodesDetail)="onTreeNodeSelectedEvent($event, 'target')"></app-tree-view>
                    </ng-container>

                    <div class="blank-content" *ngIf="!targetTaxonomyData">
                      <span class="material-icons-outlined" aria-hidden="true">error_outline</span>
                      <p class="font-bold">Select Target name in order to see Nodes</p>
                    </div>
                  </ng-container>
                  <app-preloader *ngIf="taxonomyLoading" [loaderText]="'Loading Nodes..'"
                    class="w-100 position-fixed preloader-backdrop"></app-preloader>
                </div>
              </div>


              <div class="form-group text-right">
                <button type="button" class="btn btn-primary" (click)="addSelection()"
                  [disabled]="targetNodes.length<1 && targetNodeTypes.length<1">
                  {{actionMode===CREATE_MODE ? 'Add' : 'Update'}} Selection
                </button>
              </div>
            </div>

            <div class="col-4">
              <aside class="taxonomy-selection-list h-100">
                <h3 class="mb-0">Target Selection</h3>
                <ng-container *ngIf="addedTaxonomy.target.length > 0">
                  <div class="taxonomy-selection-list-item" *ngFor="let item of addedTaxonomy.target; let i = index">
                    <div class="w-100 d-flex align-items-center">
                      <div class="col-11 px-0">
                        <p class="mb-0 font-bold">
                          <button class="btn btn-clear font-2x text-truncate text-left p-0 col-12"
                            title="{{item?.taxonomy?.title}}" (click)="onClickAddedTaxonomy(item?.taxonomy, i)">
                            {{item?.taxonomy?.title}}
                          </button>
                        </p>
                      </div>
                      <div class="col-1 text-right p-0" *ngIf="true">
                        <button class="btn btn-clear tooltip top lg position-relative"
                          data-tooltip="Delete Target selection" [attr.aria-label]="'Delete Target selection'"
                          (click)="deleteTarget(i)">
                          <em class="material-icons-outlined font-4x" aria-hidden="true">delete</em>
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <div class="taxonomy-selection-empty" *ngIf="addedTaxonomy.target.length<1">
                  <img src="assets/images/no-record.svg" class="img-fluid mb-4 pb-1" alt="no-record">
                  <p class="font-bold">You haven't made any Target selection yet.</p>
                  <p>Use the form on the left to select Target, mark selection for either Node type or Nodes and click
                    on the "Add Selection"
                    button.</p>
                </div>
              </aside>
            </div>
          </div>
        </ng-container>
        <!-- Step 2 end -->
      </div>
      <!-- end of col-8 -->
    </section>
  </modal-div>



  <modal-div class="footer-buttons">
    <button type="button" class="btn btn-primary btn-lg" data-dismiss="modal"
      [disabled]="sourceNodes.length<1 && sourceNodeTypes.length<1" (click)="onContinueClick($event)"
      *ngIf="currentStep===1">Continue</button>
    <button type="button" class="btn btn-primary btn-lg" *ngIf="currentStep===2"
      [disabled]="(addedTaxonomy.source.length<1) || (addedTaxonomy.target.length<1) || downloadLoader"
      (click)="downloadCoverageReport()">
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 132.813 132.031" class="animated-loader" *ngIf="downloadLoader" aria-hidden="true">
        <path id="loader" d="M140.625,128.906a47.379,47.379,0,0,0,8.594-20.7h16.8a67.265,67.265,0,0,1-13.281,32.422ZM108.2,149.219a47.379,47.379,0,0,0,20.7-8.594l12.109,12.109A65.626,65.626,0,0,1,108.2,166.016ZM166.016,91.8h-16.8a47.379,47.379,0,0,0-8.594-20.7l12.109-11.719A60.853,60.853,0,0,1,166.016,91.8ZM91.8,50.781A49.458,49.458,0,0,0,61.914,67.773,47.949,47.949,0,0,0,50,100a47.949,47.949,0,0,0,11.914,32.227A49.458,49.458,0,0,0,91.8,149.219v16.8q-24.609-3.125-41.6-21.875A63.594,63.594,0,0,1,33.2,100,63.594,63.594,0,0,1,50.2,55.859q16.992-18.75,41.6-21.875Z" transform="translate(-33.203 -33.984)"/>
      </svg>
      {{downloadLoader ? 'Downloading' : 'Download'}} Report
    </button>
  </modal-div>
</app-modal>
<!-- Export coverage report modal end -->
